import { Question } from '../types';

const createOptions = () => [
  { value: 1, label: '全く当てはまらない' },
  { value: 2, label: 'あまり当てはまらない' },
  { value: 3, label: 'どちらとも言えない' },
  { value: 4, label: 'やや当てはまる' },
  { value: 5, label: '非常に当てはまる' },
];

export const questions: Question[] = [
  // ========== 社会人基礎能力診断 (20問、各4問) ==========

  // A. チームワーク力 (4問)
  {
    id: 'ba-team-1',
    category: 'basic-abilities',
    subCategory: 'teamwork',
    text: 'チームメンバーと意見が異なる時でも、建設的に話し合うことができる',
    options: createOptions(),
  },
  {
    id: 'ba-team-2',
    category: 'basic-abilities',
    subCategory: 'teamwork',
    text: '自分の役割を理解し、チームの目標達成のために積極的に行動する',
    options: createOptions(),
  },
  {
    id: 'ba-team-3',
    category: 'basic-abilities',
    subCategory: 'teamwork',
    text: 'チーム内で問題が発生した時、解決に向けて積極的に動く',
    options: createOptions(),
  },
  {
    id: 'ba-team-4',
    category: 'basic-abilities',
    subCategory: 'teamwork',
    text: '自分の強みを活かしながら、チーム全体の成果向上に貢献できる',
    options: createOptions(),
  },

  // B. 目標達成力 (4問)
  {
    id: 'ba-goal-1',
    category: 'basic-abilities',
    subCategory: 'goalAchievement',
    text: '長期的な目標を設定し、それに向けて計画的に取り組むことができる',
    options: createOptions(),
  },
  {
    id: 'ba-goal-2',
    category: 'basic-abilities',
    subCategory: 'goalAchievement',
    text: '困難な目標でも、諦めずに最後までやり遂げる',
    options: createOptions(),
  },
  {
    id: 'ba-goal-3',
    category: 'basic-abilities',
    subCategory: 'goalAchievement',
    text: '進捗を定期的に確認し、必要に応じて計画を修正する',
    options: createOptions(),
  },
  {
    id: 'ba-goal-4',
    category: 'basic-abilities',
    subCategory: 'goalAchievement',
    text: '高い目標を掲げることで、自分のモチベーションを維持できる',
    options: createOptions(),
  },

  // C. メンタルタフネス (4問)
  {
    id: 'ba-mental-1',
    category: 'basic-abilities',
    subCategory: 'mentalToughness',
    text: '大きなプレッシャーを感じる場面でも、冷静に対処できる',
    options: createOptions(),
  },
  {
    id: 'ba-mental-2',
    category: 'basic-abilities',
    subCategory: 'mentalToughness',
    text: '失敗から学び、次に活かすことができる',
    options: createOptions(),
  },
  {
    id: 'ba-mental-3',
    category: 'basic-abilities',
    subCategory: 'mentalToughness',
    text: '予期せぬ変化にも柔軟に対応できる',
    options: createOptions(),
  },
  {
    id: 'ba-mental-4',
    category: 'basic-abilities',
    subCategory: 'mentalToughness',
    text: '批判やフィードバックを前向きに受け止めることができる',
    options: createOptions(),
  },

  // D. 自己成長意欲 (4問)
  {
    id: 'ba-growth-1',
    category: 'basic-abilities',
    subCategory: 'growthMindset',
    text: '新しいスキルを習得する機会があれば、積極的に取り組む',
    options: createOptions(),
  },
  {
    id: 'ba-growth-2',
    category: 'basic-abilities',
    subCategory: 'growthMindset',
    text: '自分の弱点や改善点を認識し、向上に努めている',
    options: createOptions(),
  },
  {
    id: 'ba-growth-3',
    category: 'basic-abilities',
    subCategory: 'growthMindset',
    text: '挑戦的な課題に取り組むことで、成長を実感する',
    options: createOptions(),
  },
  {
    id: 'ba-growth-4',
    category: 'basic-abilities',
    subCategory: 'growthMindset',
    text: '自分の専門分野以外のことにも興味を持ち、学ぶ姿勢がある',
    options: createOptions(),
  },

  // E. リーダーシップ (4問)
  {
    id: 'ba-leader-1',
    category: 'basic-abilities',
    subCategory: 'leadership',
    text: 'グループで課題に取り組む際、率先して行動する',
    options: createOptions(),
  },
  {
    id: 'ba-leader-2',
    category: 'basic-abilities',
    subCategory: 'leadership',
    text: '他者に影響を与え、目標に向けて動機づけることができる',
    options: createOptions(),
  },
  {
    id: 'ba-leader-3',
    category: 'basic-abilities',
    subCategory: 'leadership',
    text: 'チームの方向性を示し、メンバーをまとめることができる',
    options: createOptions(),
  },
  {
    id: 'ba-leader-4',
    category: 'basic-abilities',
    subCategory: 'leadership',
    text: 'メンバーの強みを理解し、適切な役割分担ができる',
    options: createOptions(),
  },

  // ========== RIASEC 職業興味検査 (36問、各6問) ==========

  // R: Realistic (現実的) - 6問
  {
    id: 'riasec-r-1',
    category: 'riasec',
    subCategory: 'R',
    text: '機械やツールを使って作業する仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-r-2',
    category: 'riasec',
    subCategory: 'R',
    text: '身体を動かす仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-r-3',
    category: 'riasec',
    subCategory: 'R',
    text: '具体的な成果物を作り出す仕事がしたい',
    options: createOptions(),
  },
  {
    id: 'riasec-r-4',
    category: 'riasec',
    subCategory: 'R',
    text: '屋外での活動や作業をする仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-r-5',
    category: 'riasec',
    subCategory: 'R',
    text: 'スポーツやフィットネスに関わる仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-r-6',
    category: 'riasec',
    subCategory: 'R',
    text: '技術的な問題を解決する仕事に興味がある',
    options: createOptions(),
  },

  // I: Investigative (研究的) - 6問
  {
    id: 'riasec-i-1',
    category: 'riasec',
    subCategory: 'I',
    text: 'データを分析して問題の原因を探る仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-i-2',
    category: 'riasec',
    subCategory: 'I',
    text: '複雑な問題を論理的に解決する仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-i-3',
    category: 'riasec',
    subCategory: 'I',
    text: '研究や調査を行う仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-i-4',
    category: 'riasec',
    subCategory: 'I',
    text: '「なぜ」という疑問を深く追求する仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-i-5',
    category: 'riasec',
    subCategory: 'I',
    text: '技術やテクノロジーに関する仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-i-6',
    category: 'riasec',
    subCategory: 'I',
    text: '一人でじっくり考えたり調べたりする仕事に興味がある',
    options: createOptions(),
  },

  // A: Artistic (芸術的) - 6問
  {
    id: 'riasec-a-1',
    category: 'riasec',
    subCategory: 'A',
    text: '新しいアイデアを形にする仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-a-2',
    category: 'riasec',
    subCategory: 'A',
    text: '創造的な表現活動に関わる仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-a-3',
    category: 'riasec',
    subCategory: 'A',
    text: '自由な発想で取り組める仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-a-4',
    category: 'riasec',
    subCategory: 'A',
    text: 'メディアやエンターテインメント業界に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-a-5',
    category: 'riasec',
    subCategory: 'A',
    text: '既存の枠にとらわれず自由に発想する仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-a-6',
    category: 'riasec',
    subCategory: 'A',
    text: '感性を活かせる仕事がしたい',
    options: createOptions(),
  },

  // S: Social (社会的) - 6問
  {
    id: 'riasec-s-1',
    category: 'riasec',
    subCategory: 'S',
    text: '他人の成長をサポートする仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-s-2',
    category: 'riasec',
    subCategory: 'S',
    text: '教育や指導に関わる仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-s-3',
    category: 'riasec',
    subCategory: 'S',
    text: '他者の問題解決を手助けする仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-s-4',
    category: 'riasec',
    subCategory: 'S',
    text: 'カウンセリングやサポートをする仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-s-5',
    category: 'riasec',
    subCategory: 'S',
    text: '医療や福祉の分野に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-s-6',
    category: 'riasec',
    subCategory: 'S',
    text: '人の役に立てる仕事に興味がある',
    options: createOptions(),
  },

  // E: Enterprising (企業的) - 6問
  {
    id: 'riasec-e-1',
    category: 'riasec',
    subCategory: 'E',
    text: 'チームを率いて目標を達成する仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-e-2',
    category: 'riasec',
    subCategory: 'E',
    text: 'ビジネスや経営に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-e-3',
    category: 'riasec',
    subCategory: 'E',
    text: '人を説得したり交渉したりする仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-e-4',
    category: 'riasec',
    subCategory: 'E',
    text: 'リスクを取ってでも新しいことに挑戦したい',
    options: createOptions(),
  },
  {
    id: 'riasec-e-5',
    category: 'riasec',
    subCategory: 'E',
    text: '競争的な環境で働くことに興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-e-6',
    category: 'riasec',
    subCategory: 'E',
    text: '影響力を持ち、意思決定に関わりたい',
    options: createOptions(),
  },

  // C: Conventional (慣習的) - 6問
  {
    id: 'riasec-c-1',
    category: 'riasec',
    subCategory: 'C',
    text: '決められた手順に従って正確に進める仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-c-2',
    category: 'riasec',
    subCategory: 'C',
    text: 'データ入力や事務処理をする仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-c-3',
    category: 'riasec',
    subCategory: 'C',
    text: '細部にまで注意を払う緻密な仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-c-4',
    category: 'riasec',
    subCategory: 'C',
    text: '数字や統計を扱う仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-c-5',
    category: 'riasec',
    subCategory: 'C',
    text: '効率的なシステムや仕組みを作る仕事に興味がある',
    options: createOptions(),
  },
  {
    id: 'riasec-c-6',
    category: 'riasec',
    subCategory: 'C',
    text: '会計や財務の仕事に興味がある',
    options: createOptions(),
  },

  // ========== 仕事価値観検査 (16問、各価値観2問) ==========

  // 経済的報酬
  {
    id: 'value-economic-1',
    category: 'work-values',
    subCategory: 'economicReward',
    text: '仕事を選ぶとき、給与や待遇面を最も重視する',
    options: createOptions(),
  },
  {
    id: 'value-economic-2',
    category: 'work-values',
    subCategory: 'economicReward',
    text: '年収が高ければ、業務内容に多少不満があっても頑張れる',
    options: createOptions(),
  },

  // 安定性
  {
    id: 'value-stability-1',
    category: 'work-values',
    subCategory: 'stability',
    text: '大企業や公務員のように、雇用が安定している職場で働きたい',
    options: createOptions(),
  },
  {
    id: 'value-stability-2',
    category: 'work-values',
    subCategory: 'stability',
    text: '挑戦的だがリスクのある仕事より、将来の見通しが立ちやすい仕事を選びたい',
    options: createOptions(),
  },

  // ワークライフバランス
  {
    id: 'value-balance-1',
    category: 'work-values',
    subCategory: 'workLifeBalance',
    text: '残業が少なく、休日にしっかり自分の時間を確保できる仕事が理想だ',
    options: createOptions(),
  },
  {
    id: 'value-balance-2',
    category: 'work-values',
    subCategory: 'workLifeBalance',
    text: '昇進や高い給与よりも、家族や趣味との時間を優先したい',
    options: createOptions(),
  },

  // 社会貢献
  {
    id: 'value-social-1',
    category: 'work-values',
    subCategory: 'socialContribution',
    text: '自分の仕事が社会の課題解決や人の助けにつながっていることにやりがいを感じる',
    options: createOptions(),
  },
  {
    id: 'value-social-2',
    category: 'work-values',
    subCategory: 'socialContribution',
    text: '利益を追求する仕事よりも、地域や社会のために働いている実感がある仕事がしたい',
    options: createOptions(),
  },

  // 自己成長
  {
    id: 'value-growth-1',
    category: 'work-values',
    subCategory: 'selfGrowth',
    text: '未経験の分野でも、新しいことを学び挑戦できる環境で働きたい',
    options: createOptions(),
  },
  {
    id: 'value-growth-2',
    category: 'work-values',
    subCategory: 'selfGrowth',
    text: '研修制度や資格取得支援など、自分の成長をサポートしてくれる職場が重要だ',
    options: createOptions(),
  },

  // 人間関係
  {
    id: 'value-relation-1',
    category: 'work-values',
    subCategory: 'relationships',
    text: '仲間と信頼関係を築きながら、チームで成果を出す働き方が好きだ',
    options: createOptions(),
  },
  {
    id: 'value-relation-2',
    category: 'work-values',
    subCategory: 'relationships',
    text: '上司や同僚との相性は、給与や仕事内容と同じくらい大切だと思う',
    options: createOptions(),
  },

  // 独立性
  {
    id: 'value-independence-1',
    category: 'work-values',
    subCategory: 'independence',
    text: '細かく指示されるより、自分で考えて進め方を決める仕事が好きだ',
    options: createOptions(),
  },
  {
    id: 'value-independence-2',
    category: 'work-values',
    subCategory: 'independence',
    text: '場所や時間に縛られず、自分のスタイルで働ける環境が理想だ',
    options: createOptions(),
  },

  // 達成感
  {
    id: 'value-achievement-1',
    category: 'work-values',
    subCategory: 'achievement',
    text: '目標を達成した時の手応えが、仕事を続ける最大のモチベーションだ',
    options: createOptions(),
  },
  {
    id: 'value-achievement-2',
    category: 'work-values',
    subCategory: 'achievement',
    text: '自分の努力や成果が周囲からきちんと評価される環境で働きたい',
    options: createOptions(),
  },

  // ========== ポータブルスキル診断 (24問、各3問) ==========

  // コミュニケーション力 (3問)
  {
    id: 'skill-comm-1',
    category: 'portable-skills',
    subCategory: 'communication',
    text: '自分の考えを分かりやすく伝えることができる',
    options: createOptions(),
  },
  {
    id: 'skill-comm-2',
    category: 'portable-skills',
    subCategory: 'communication',
    text: '相手の立場に立って話すことができる',
    options: createOptions(),
  },
  {
    id: 'skill-comm-3',
    category: 'portable-skills',
    subCategory: 'communication',
    text: '初対面の人とも臆せずコミュニケーションが取れる',
    options: createOptions(),
  },

  // プレゼンテーション力 (3問)
  {
    id: 'skill-present-1',
    category: 'portable-skills',
    subCategory: 'presentation',
    text: '人前で話すことに抵抗がない',
    options: createOptions(),
  },
  {
    id: 'skill-present-2',
    category: 'portable-skills',
    subCategory: 'presentation',
    text: '聴衆を引き付ける話し方ができる',
    options: createOptions(),
  },
  {
    id: 'skill-present-3',
    category: 'portable-skills',
    subCategory: 'presentation',
    text: '質疑応答に的確に対応できる',
    options: createOptions(),
  },

  // 交渉力 (3問)
  {
    id: 'skill-nego-1',
    category: 'portable-skills',
    subCategory: 'negotiation',
    text: '相手の意見を尊重しながら自分の主張もできる',
    options: createOptions(),
  },
  {
    id: 'skill-nego-2',
    category: 'portable-skills',
    subCategory: 'negotiation',
    text: 'Win-Winの解決策を見つけることができる',
    options: createOptions(),
  },
  {
    id: 'skill-nego-3',
    category: 'portable-skills',
    subCategory: 'negotiation',
    text: '対立する場面でも冷静に落としどころを探れる',
    options: createOptions(),
  },

  // 傾聴力 (3問)
  {
    id: 'skill-listen-1',
    category: 'portable-skills',
    subCategory: 'listening',
    text: '相手の話を最後まで注意深く聞くことができる',
    options: createOptions(),
  },
  {
    id: 'skill-listen-2',
    category: 'portable-skills',
    subCategory: 'listening',
    text: '適切な質問をして相手の考えを引き出せる',
    options: createOptions(),
  },
  {
    id: 'skill-listen-3',
    category: 'portable-skills',
    subCategory: 'listening',
    text: '相手が伝えたいことの本質を理解できる',
    options: createOptions(),
  },

  // 問題発見力 (3問)
  {
    id: 'skill-problem-1',
    category: 'portable-skills',
    subCategory: 'problemIdentification',
    text: '表面化していない潜在的な問題に気づくことができる',
    options: createOptions(),
  },
  {
    id: 'skill-problem-2',
    category: 'portable-skills',
    subCategory: 'problemIdentification',
    text: '「なぜそうなるのか」を掘り下げて本質を見抜ける',
    options: createOptions(),
  },
  {
    id: 'skill-problem-3',
    category: 'portable-skills',
    subCategory: 'problemIdentification',
    text: '複数の視点から問題を捉えられる',
    options: createOptions(),
  },

  // 分析力 (3問)
  {
    id: 'skill-analysis-1',
    category: 'portable-skills',
    subCategory: 'analysis',
    text: '情報を整理して体系的に考えることができる',
    options: createOptions(),
  },
  {
    id: 'skill-analysis-2',
    category: 'portable-skills',
    subCategory: 'analysis',
    text: 'データから傾向やパターンを見つけられる',
    options: createOptions(),
  },
  {
    id: 'skill-analysis-3',
    category: 'portable-skills',
    subCategory: 'analysis',
    text: '原因と結果の関係を論理的に説明できる',
    options: createOptions(),
  },

  // 計画力 (3問)
  {
    id: 'skill-planning-1',
    category: 'portable-skills',
    subCategory: 'planning',
    text: '優先順位をつけて計画を立てられる',
    options: createOptions(),
  },
  {
    id: 'skill-planning-2',
    category: 'portable-skills',
    subCategory: 'planning',
    text: 'リスクを予測して事前に対策を考えられる',
    options: createOptions(),
  },
  {
    id: 'skill-planning-3',
    category: 'portable-skills',
    subCategory: 'planning',
    text: 'スケジュール管理が得意だ',
    options: createOptions(),
  },

  // 実行力 (3問)
  {
    id: 'skill-execution-1',
    category: 'portable-skills',
    subCategory: 'execution',
    text: '計画を着実に実行に移すことができる',
    options: createOptions(),
  },
  {
    id: 'skill-execution-2',
    category: 'portable-skills',
    subCategory: 'execution',
    text: '困難があっても粘り強く取り組める',
    options: createOptions(),
  },
  {
    id: 'skill-execution-3',
    category: 'portable-skills',
    subCategory: 'execution',
    text: '締め切りを守って成果を出せる',
    options: createOptions(),
  },
];

export default questions;
